export const homeURL = 'https://onthemove-35981.web.app'; // no trailing slash

export const saveDisabledURLs = ['/', '/contacts', '/event/services', '/event/talent', '/venues'];

export const gridW = { xs: 60, sm: 100, md: 140, lg: 200, xl: 300 };

export const rowHeight = 32;
export const headerHeight = 132;

export const timeOptionShort: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: true
};

export default saveDisabledURLs;
